import { PaymentMethodSelector as PaymentMethodSelectorShared } from '../../../../components/Containers/ReviewCheckoutDrawer/PaymentMethod/PaymentMethodSelector';
import { useFlow } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';

export const PaymentMethodSelector = () => {
  const drawController = usePreAuthDrawCtx();
  const { goToStep } = useFlow();

  const [emitter] = useAnalyticsEmitter();

  return (
    <PaymentMethodSelectorShared
      canSave={
        drawController.selectedPaymentMethodId !== null ||
        drawController.usingNewPaymentMethod
      }
      onSave={async (paymentMethodId) => {
        if (!paymentMethodId) return;
        drawController.setPaymentErrorCode(null);
        drawController.setUsingNewPaymentMethod(false);
        drawController.setSelectedPaymentMethodId(paymentMethodId || null);
        await drawController.updateDrawEntryIntent();
        emitter('existing', 'selected');

        goToStep('apply');
      }}
      paymentMethods={drawController.paymentMethods || []}
      selectedPaymentMethodId={drawController.selectedPaymentMethodId || null}
      setSelectedPaymentMethodId={drawController.setSelectedPaymentMethodId}
    />
  );
};
